// src/components/PublicHome.js
import React from 'react';
import { Link } from 'react-router-dom';

const PublicHome = () => {
  return (
    <div className="container mt-3">

      {/* Hero Section */}
      <div className="text-center pt-3 pb-3 mb-4">
        <div className="mb-2">
          <img src="/logo192.png" alt="Taxi-Local.uk" style={{ maxWidth: '150px' }} />
        </div>
        <h1 className="fw-bold mb-2">Taxi-Local.uk</h1>
        <p className="lead mb-0">Linking local taxis and clients in real-time</p>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-5">
        <Link to="/fare-calculator" className="btn btn-success btn-lg">
          Book Taxi Online
        </Link>
      </div>

      {/* Info Cards */}
      <div className="px-3">
        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h2 className="mb-0">Taxi-Local.UK: A Smarter Way to Book Rural Taxis in Britain</h2>
  </div>
  <div className="card-body text-center">
    <p>
      Getting a taxi in rural Britain has long been a frustrating task—especially when time is tight.
      Too often, passengers call through lists of firms only to hear: "Sorry, we're fully booked."
      That's where Taxi-Local.UK steps in—revolutionising how rural journeys are booked by connecting
      customers with a network of independent local taxi operators, all in one go.
    </p>
  </div>
</div>


        <div className="card mb-4"> 
  <div className="card-header bg-warning text-center">
    <h4 className="mb-0">Connecting Rural Britain, One Booking at a Time</h4>
  </div>
  <div className="card-body text-center">
    <p>
      Taxi-Local.UK isn't just another taxi app. It's a smart dispatching platform for rural and semi-rural
      communities. Submit your journey request, and it goes to a cluster of local firms in real time. No response?
      No problem. You'll get a list of all contacted firms and their phone numbers—transparent, simple, and fast.
    </p>
  </div>
</div>


        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h4 className="mb-0">How It Works</h4>
  </div>
  <div className="card-body">
    <div className="row">
      <div className="col-md-4 text-center mb-3">
        <div className="h2 text-primary">1</div>
        <h5>Enter Your Journey</h5>
        <p>Tell us where you're going and when you need to be there.</p>
      </div>
      <div className="col-md-4 text-center mb-3">
        <div className="h2 text-primary">2</div>
        <h5>We Contact Local Firms</h5>
        <p>Your request goes to multiple taxi companies in your area simultaneously.</p>
      </div>
      <div className="col-md-4 text-center mb-3">
        <div className="h2 text-primary">3</div>
        <h5>Get Your Taxi</h5>
        <p>Receive immediate acceptance from Taxi Company or receive estimated arrival times which you can call and accept.</p>
      </div>
    </div>
  </div>
</div>

        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h4 className="mb-0">Why Choose Taxi-Local.UK?</h4>
  </div>
  <div className="card-body">
    <div className="row">
      <div className="col-md-6 mb-3">
        <h5><i className="bi bi-clock text-primary me-2"></i>Real-Time Availability</h5>
        <p>See which firms are available right now, not just their published schedules.</p>
      </div>
      <div className="col-md-6 mb-3">
        <h5><i className="bi bi-geo-alt text-primary me-2"></i>Local Knowledge</h5>
        <p>Work with drivers who know your area inside and out.</p>
      </div>
      <div className="col-md-6 mb-3">
        <h5><i className="bi bi-shield-check text-primary me-2"></i>Licensed & Insured</h5>
        <p>All our partner firms are fully licensed and insured for your peace of mind.</p>
      </div>
      <div className="col-md-6 mb-3">
        <h5><i className="bi bi-currency-pound text-primary me-2"></i>Transparent Pricing</h5>
        <p>Get an estimate of your journey before booking a taxi using local authority pricing tariffs. Once your booking is confirmed, please check if any add-ons apply.</p>
      </div>
    </div>
  </div>
</div>

        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h4 className="mb-0">Ready to Book Your Next Journey?</h4>
  </div>
  <div className="card-body text-center">
    <p className="lead">
      Join thousands of satisfied customers who have discovered the smart way to book rural taxis.
    </p>
    <Link to="/fare-calculator" className="btn btn-success btn-lg me-3">
      Book Taxi Online
    </Link>
    <Link to="/become-a-member" className="btn btn-outline-primary btn-lg">
      Join Our Network
    </Link>
  </div>
</div>

      </div>
    </div>
  );
};

export default PublicHome;
